<template>
<div class="constructor_scroll">
        <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
            <div class="tittle">
                <div class="breadcrumbs">
                    <router-link to="/feedbacks">Обратная связь</router-link>
                    <span></span>
                    <h1>{{ feedback.name }}</h1>
                </div>
            </div>
             <div class="edit_main edit_feed">
             <div class="folder">
                <div class="view_message column">
                    <h2>Просмотр сообщения</h2>
                    <p class="list first">
                        <span class="caption">Имя</span>
                        <span class="text">{{feedback.name}}</span>
                    </p>
                    <p class="list" v-if="feedback.city">
                        <span class="caption">Email</span>
                        <span class="text">{{feedback.city}}</span>
                    </p>
                    <p class="list" v-if="feedback.img">
                        <span class="caption">Телефон</span>
                        <span class="text">{{feedback.img}}</span>
                    </p>
                    <p class="list">
                        <span class="caption">Дата/время</span>
                        <span class="text">{{feedback.created_at}}</span>
                    </p>
                    <p class="list message-edit">
                        <span class="caption">Сообщение</span>
                        <span class="text message">{{feedback.message}}</span>
                    </p>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex'

    const {mapState, mapMutations} = createNamespacedHelpers('mainPage')

    export default {
        data() {
            return {
                feedback: [],
                adminComment: ''
            }
        },
        computed: {
            ...mapState([
                'isLoaded'
            ]),
            apiDomain() {
                return this.$store.state.apiDomain
            },
            apiUrls() {
                return this.$store.state.apiUrls
            }
        },
        methods: {
            addComment(id) {
                this.$http.put(
                    `${this.apiUrls.feedback}/${id}`,
                    {
                        object: JSON.stringify({
                            comment: this.adminComment
                        })
                    }
                ).then(() => {
                    this.feedback.comment = this.adminComment
                    this.adminComment = ''
                })
            }
        },
        created() {
            this.$http.get(
                `${this.apiUrls.feedback}/${this.$route.path.split('/')[2]}?admin=true`
            ).then(response => {
                this.feedback = response.data.data
            })
        }
    }
</script>
<style lang="scss" scoped>
    $grey-6: #6e7074;

    .container {
        background: #fafcfb;
    }

    .edit_main .folder {
        display: flex;
    }

    .constructor_scroll .container-block .folder {
        margin: -12px;
    }

    .constructor_scroll .container-block .folder .column {
        margin: 12px 12px;

        @media screen and (max-width: 1100px) {
            margin: 12px 0;
        }
    }

    .edit_feed .folder .column {
        width: 100%;
    }

    .edit_main .folder .column .message-edit {
        border-top: none;
        margin-top: 0;
        padding: 7.5px 18px;
        align-items: flex-start;

        & .caption {
            // margin-top: 11px;
        }
    }

    .edit_main .folder h2 {
        font-size: 15px;
    }

    .edit_main .folder .column.comment .list {
        align-items: flex-start;
    }

    .edit_main .folder .view_message h2,
    .edit_main .folder .comment h2 {
        margin-bottom: 10.5px;
    }

    .no-comments {
        margin-bottom: 0;
        text-align: center;
        width: 100%;
        color: $grey-6;
    }

    .comment.column {
        align-self: flex-start;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/feedbacks/pages/View.vue